export function ModalOverrides() {
  return {
    Modal: {
      slotProps: {
        backdrop: {
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    },
  }
}
